module.exports = __webpack_public_path__ + "static/media/orbitron-medium.22cc64f6.ttf";